export default __webpack_public_path__ + "static/media/yen2stories.22a1ca5e.jpg";